(function () {
    'use strict';
    angular
        .module('app')
        .directive('yesNoCancelBox', yesNoCancelBox);
    yesNoCancelBox.$inject = ['$window', '$rootScope', '$scope', '$timeout', 'ngClipboard', '$mdDialog'];
    function yesNoCancelBox($window, $rootScope, scope, $timeout, ngClipboard, $mdDialog) {
        var directive = {
            link: link,
            restrict: 'EA',
            //scope: {
            //    msgBoxShown: '=?'
            //},
            //controller: 'yesNoCancelBox',
            templateUrl: 'app/msgBox/yesNoCancelBox.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();